export enum ClientAgreementType {
  AI_ASSISTANT = 'AI_ASSISTANT',
}
